import { DataFieldType } from './data-field-type';
import { ContentLanguagesService } from '../utilities/fi-services/content-languages.service';
import { ContentLanguageLabelModel } from '@fi-shared/models';
import { DataFieldPropertyType } from './data-field-property-type';
import { DataFieldVisibleForType } from './data-field-visible-for-type';
import { DataFieldPreSetOptionModel } from './data-field-pre-set-option.model';
import { IDataFieldModel } from '@fi-app/data-field/data-field';
import { IDataFieldValueModel } from '@fi-shared/models/common';

export class DataFieldModel implements IDataFieldModel {
    Id: 0;
    Type: DataFieldType = DataFieldType.Text;
    PropertyType: DataFieldPropertyType = DataFieldPropertyType.Custom;
    IsEnabled: boolean = true;
    IsMandatory: boolean = false;
    IsSetRequired: boolean = false;
    CanSwitchRequired: boolean = true;
    VisibleFor: DataFieldVisibleForType = DataFieldVisibleForType.AdminOnly;
    Names: ContentLanguageLabelModel[] = [];
    Name: string;
    Value: string;
    IsMultipleChoice: boolean;
    PreSetOptions: Array<DataFieldPreSetOptionModel> = [];
    PreSetValues: Array<DataFieldPreSetOptionModel> = [];

    IsMaterialLayout: boolean = false;

    CreatedOn = new Date();
    CreatedByUserId = 0;
    CreatedByUserName = '';

    ChangedOn = new Date();
    ChangedByUserId = 0;
    ChangedByUserName = '';

    constructor(contentLanguagesService: ContentLanguagesService, data?) {
        if (data) {
            this.Id = data.Id;
            this.Name = data.Name;
            this.Type = data.Type;
            this.PropertyType = data.PropertyType;
            this.IsEnabled = data.IsEnabled;
            this.IsMandatory = data.IsMandatory;
            this.IsSetRequired = data.IsSetRequired;
            this.CanSwitchRequired = data.CanSwitchRequired;
            this.VisibleFor = data.VisibleFor;
            this.Value = data.Value;
            this.IsMultipleChoice = data.IsMultipleChoice;
            this.PreSetOptions = data.PreSetOptions || [];
            this.PreSetValues = data.PreSetValues || [];

            this.CreatedOn = new Date(data.CreatedOn);
            this.CreatedByUserId = data.CreatedByUserId;
            this.CreatedByUserName = data.CreatedByUserName;

            this.ChangedOn = new Date(data.ChangedOn);
            this.ChangedByUserId = data.ChangedByUserId;
            this.ChangedByUserName = data.ChangedByUserName;

            this.IsMaterialLayout = data.IsMaterialLayout;

            this.initializeApplicationLanguages(contentLanguagesService, data);
        }
    }

    private initializeApplicationLanguages(contentLanguagesService: ContentLanguagesService, data) {
        const applicationLanguages = contentLanguagesService.GetApplicationLanguages();
        for (let i = 0; i < applicationLanguages.length; i++) {
            let value = '';
            const label = data.Names.find((n) => applicationLanguages[i].Id == n.ContentLanguageId);

            if (label) value = label.Value;

            this.Names.push(
                new ContentLanguageLabelModel(applicationLanguages[i].Id, value, applicationLanguages[i].SortIndex),
            );
        }
    }
}

export function getDataFieldsSaveData(dataFields: Array<DataFieldModel>): Array<IDataFieldValueModel> {
    return dataFields.reduce((currentValue: Array<IDataFieldValueModel>, field: DataFieldModel) => {
        if (field.PropertyType === DataFieldPropertyType.Custom) {
            currentValue.push({
                FieldId: field.Id,
                Value: field.Value,
                PreSetOptionValues: field.PreSetValues.map((item) => item.Id),
            });
        }

        return currentValue;
    }, []);
}
